export default __webpack_public_path__ + "static/media/equal.447e1e19.svg";